module.exports = __webpack_public_path__ + "media/images/flags/DE-95e0484fa895b13de17ba6d3d1114e22.svg";